import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  Button,
  FormHelperText,
  Grid,
  FormControlLabel,
  Switch,
  Typography,
  Box,
} from "@mui/material";

import RichTextEditor from "components/Shared/RichTextEditor";
import AppForm from "components/Shared/AppForm";
import LoadingWrapper from "components/Shared/LoadingWrapper";

const INITIAL_STATE = {
  template: "",
  isActive: true,
};

const EMAIL_TEMPLATE_LIST = [
  {
    type: "Welcome",
    helperText: "eg: [userName], [email], [password], [loginLink]",
  },
  {
    type: "Forgot Password",
    helperText: "eg: [userName], [otp], [resetLink]",
  },
  {
    type: "Reset Password",
    helperText: "eg: [userName], [password], [resetLink]",
  },
];

const EmailTemplateForm = ({
  emailTemplateDetail = null,
  onSubmit = () => { },
  isBusy = false,
}) => {
  const navigate = useNavigate();

  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  // methods
  const getHelperText = (type) => {
    const template = EMAIL_TEMPLATE_LIST.find((item) => item.type === type);
    return template ? template?.helperText : "";
  };

  const handleDragStart = (e, variable) => {
    e.dataTransfer.setData("text/plain", `[${variable}]`);
  };

  const handleEmailTemplateSubmit = (data) => {
    const _payload = {
      ...data,
    };

    onSubmit(_payload);
  };

  React.useEffect(() => {
    if (!emailTemplateDetail) return;

    reset({
      ...emailTemplateDetail,
    });

    return () => {
      reset(INITIAL_STATE);
    };
  }, [reset, emailTemplateDetail]);

  return (
    <LoadingWrapper loading={isBusy}>
      <AppForm>
        <AppForm.Content>
          <Grid container direction={"column"} spacing={3}>
            <Grid item xs={12}>
              <p className="font-medium ">
                {emailTemplateDetail?.for} Template
              </p>
            </Grid>

            {emailTemplateDetail?.variables && emailTemplateDetail.variables.length > 0 ? (
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Drag Variables into Template
                </Typography>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  sx={{ padding: 1, border: "1px solid #ccc" }}
                >
                  {emailTemplateDetail.variables.map((variable, index) => (
                    <Box
                      key={index}
                      draggable
                      onDragStart={(e) => handleDragStart(e, variable)}
                      sx={{
                        padding: "2px 5px",
                        border: "1px solid #ccc",
                        borderRadius: "1px",
                        margin: "5px",
                        cursor: "grab",
                        backgroundColor: "#f1f1f1",
                      }}
                    >
                      {variable}
                    </Box>
                  ))}
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  No variables found for this template.
                </Typography>
              </Grid>
            )}


            <Grid item xs={12}>
              <Controller
                name="template"
                control={control}
                rules={{ required: "Enter response." }}
                render={({ field: { onChange } }) => (
                  <RichTextEditor
                    initialValue={
                      emailTemplateDetail?.template
                        ? emailTemplateDetail.template
                        : "<p>Enter Response.</p>"
                    }
                    onChange={onChange}
                    height={400}
                  />
                )}
              />

              {!!errors?.template ? (
                <FormHelperText error>{errors.template.message}</FormHelperText>
              ) : (
                <FormHelperText>
                  Please make sure you include template variables.
                  {getHelperText(emailTemplateDetail?.for)}
                </FormHelperText>
              )}
            </Grid>

            <Grid item xs={6}>
              <Controller
                name="isActive"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={field.value}
                        value={field?.value}
                        {...field}
                      />
                    }
                    label="Is Active?"
                  />
                )}
              />
            </Grid>
          </Grid>
        </AppForm.Content>
        <AppForm.Actions>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSubmit(handleEmailTemplateSubmit)}
          >
            Update
          </Button>
        </AppForm.Actions>
      </AppForm>
    </LoadingWrapper>
  );
};

export default EmailTemplateForm;
